import { ReadNucleoDto } from '@/api.types';
import { normalizeOptionalReference } from '@/shared/utils/formZod.schema.utils';

function str(value: unknown): string {
  return value == null ? '' : String(value);
}

/** Normaliza resposta da API para o formulário (Zod não aceita `null` em string). */
export function normalizeNucleoFormFromApi(data: ReadNucleoDto): ReadNucleoDto {
  return {
    ...data,
    nome: str(data.nome),
    resolucao: str(data.resolucao),
    ordem: data.ordem ?? 0,
    maximoIntegrantes: data.maximoIntegrantes ?? 0,
    maximoMembros: data.maximoMembros ?? 0,
    telefone: data.telefone
      ? {
          ...data.telefone,
          numero: str(data.telefone.numero),
        }
      : data.telefone,
    substituto1: normalizeOptionalReference(data.substituto1),
    substituto2: normalizeOptionalReference(data.substituto2),
    diretoria: normalizeOptionalReference(data.diretoria),
  };
}
